import {
  LOGGED_IN_USER_SITE_ID,
  LOGGED_IN_USER_SITE_TYPE,
} from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";

export const CASING_TYPE = {
  "Production casing": "Production Casing",
  "Surface casing": "Surface Casing",
};

/**
 * 1 --> "Head Office(HO)"
 * 2 --> "Regional Office(s) (RO)"
 * 3 --> Mines Level",
 */
export const UserWorkFlowRoleList = [
  {
    name: "reporterOfficer",
    label: "RO",
    value: false,
    scope: "Global",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "safetyOfficer",
    label: "SO",
    value: false,
    scope: "Global",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "minesManager",
    label: "MM",
    value: false,
    scope: "Global",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "regionalOfficer",
    label: "Regional Officer",
    value: false,
    scope: "Global",
    1: false,
    2: true,
    3: false,
  },
  {
    name: "vflOfficer",
    label: "VFL",
    value: false,
    scope: "VFL",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "vto",
    label: "VTO",
    value: false,
    scope: "Training",
    1: false,
    2: false,
    3: true,
  },
  {
    name: "medicalOfficer",
    label: "Medical Officer",
    value: false,
    scope: "Medical",
    1: false,
    2: false,
    3: true,
  },
  {
    name: "meeting",
    label: "Meeting",
    value: false,
    scope: "Meeting",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "regionalManager",
    label: "Regional Manager",
    value: false,
    scope: "OHSE",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "managingDirector",
    label: "Managing Director",
    value: false,
    scope: "OHSE",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "directorOperations",
    label: "Director Operations",
    value: false,
    scope: "OHSE",
    1: true,
    2: true,
    3: true,
  },
  {
    name: "headSafety",
    label: "Head Safety",
    value: false,
    scope: "Global",
    1: true,
    2: true,
    3: true,
  },
  // As discussed
  // {
  //   name: "investigator",
  //   label: "Investigator",
  //   value: false,
  //   1: true,
  //   2: true,
  //   3: true,
  // },
];

export const SITE_TYPE = { ho: "HO", ro: "RO", mines: "Mines" };

export const ACTIVE_MODULE = {
  vfl: "VFL",
  training: "Training",
  ohse: "OHSE",
  meeting: "Meeting",
  capa: "CAPA",
  incident: "Incident Management",
  personnelHealthManagement: "Personnel Health Management",
  formA: "Form A Management",
  global: "Global",
};

export const INCIDENT_ROLES = [
  {
    name: "reporterOfficer",
    label: "Reporting Officer",
    value: false,
    scope: "Incident Management",
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "investigator",
    label: "Investigator",
    value: false,
    scope: "Incident Management",
    // 1: true,
    // 2: true,
    // 3: true,
  },
];

export const VFL_ROLES = [
  {
    name: "vflOfficer",
    label: "VFL Executive",
    value: false,
    scope: "VFL",
    // 1: true,
    // 2: true,
    // 3: true,
  },
];

// export const OHSE_ROLES = [
//   {
//     name: "VFLExecutive",
//     label: "VFL Executive",
//     value: false,
//     scope: "Global",
//     1: true,
//     2: true,
//     3: true,
//   },
// ];

export const TRAINING_ROLES = [
  {
    name: "vto",
    label: "VTO",
    value: false,
    scope: "Training",
    // 1: false,
    // 2: false,
    // 3: true,
  },
];

export const MEDICAL_ROLES = [
  {
    name: "medicalOfficer",
    label: "Medical Officer",
    value: false,
    scope: "Medical",
    // 1: false,
    // 2: false,
    // 3: true,
  },
];

export const FORMA_ROLES = [
  {
    name: "Form A Editor",
    label: "Form A Editor",
    value: false,
    scope: "Form A",
    // 1: false,
    // 2: false,
    // 3: true,
  },
  {
    name: "Form A Viewer",
    label: "Form A Viewer",
    value: false,
    scope: "Form A",
    // 1: false,
    // 2: false,
    // 3: true,
  },
];
export const SUPPORT_ROLES = [
  {
    name: "support",
    label: "Create ticket",
    value: false,
    scope: "Support",
    // 1: false,
    // 2: false,
    // 3: true,
  },
];

export const HO_ROLES = [
  {
    name: "headSafety",
    label: "Head Safety",
    value: false,
    scope: "Global",
    commonRole: [
      "Incident Management",
      "VFL",
      "Training",
      "OHSE",
      "CAPA",
      "Personnel Health Management",
      "Form A Management",
    ],
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "minesManager",
    label: "Mines Manager - HO",
    value: false,
    scope: "Global",
    commonRole: [
      "Incident Management",
      "VFL",
      "Training",
      "OHSE",
      "CAPA",
      "Personnel Health Management",
      "Form A Management",
    ],
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "directorOperations",
    label: "Director Operations",
    value: false,
    scope: "Global",
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "directorTechnical",
    label: "Director Technical",
    value: false,
    scope: "Global",
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "managingDirector",
    label: "Managing Director",
    value: false,
    scope: "Global",
    // 1: true,
    // 2: true,
    // 3: true,
  },
];

export const RO_ROLES = [
  {
    name: "safetyOfficer",
    label: "Safety Officer - RO",
    value: false,
    scope: "Global",
    commonRole: [
      "Incident Management",
      "VFL",
      "Training",
      "OHSE",
      "CAPA",
      "Personnel Health Management",
      "Form A Management",
    ],
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "minesManager",
    label: "Mines Manager - RO",
    value: false,
    scope: "Global",
    commonRole: [
      "Incident Management",
      "VFL",
      "Training",
      "OHSE",
      "CAPA",
      "Personnel Health Management",
      "Form A Management",
    ],
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "hrManager",
    label: "HR Manager - RO",
    value: false,
    scope: "Global",
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "hrHead",
    label: "HR Head - RO",
    value: false,
    scope: "Global",
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "regionalManager",
    label: "Regional Manager",
    value: false,
    scope: "Global",
    // 1: true,
    // 2: true,
    // 3: true,
  },
];

export const MINE_ROLES = [
  {
    name: "safetyOfficer",
    label: "Mines Safety Officer",
    value: false,
    scope: "Global",
    commonRole: [
      "Incident Management",
      "VFL",
      "Training",
      "OHSE",
      "CAPA",
      "Personnel Health Management",
      "Form A Management",
    ],
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "minesManager",
    label: "Mines Manager",
    value: false,
    scope: "Global",
    commonRole: [
      "Incident Management",
      "VFL",
      "Training",
      "OHSE",
      "CAPA",
      "Personnel Health Management",
      "Form A Management",
    ],
    // 1: true,
    // 2: true,
    // 3: true,
  },
  {
    name: "hrManager",
    label: "HR Manager - Mines",
    value: false,
    scope: "Global",
    // 1: true,
    // 2: true,
    // 3: true,
  },
];

export const HO_Work_Flow_Role_List = [
  ...HO_ROLES,
  ...INCIDENT_ROLES,
  ...VFL_ROLES,
  ...TRAINING_ROLES,
  ...MEDICAL_ROLES,
  ...FORMA_ROLES,
  ...SUPPORT_ROLES,
];

export const RO_Work_Flow_Role_List = [
  ...RO_ROLES,
  ...INCIDENT_ROLES,
  ...VFL_ROLES,
  ...TRAINING_ROLES,
  ...MEDICAL_ROLES,
  ...FORMA_ROLES,
  ...SUPPORT_ROLES,
];

export const MINE_Work_Flow_Role_List = [
  ...MINE_ROLES,
  ...INCIDENT_ROLES,
  ...VFL_ROLES,
  ...TRAINING_ROLES,
  ...MEDICAL_ROLES,
  ...FORMA_ROLES,
  ...SUPPORT_ROLES,
];

export const USER_Work_Flow_Role_List = () => {
  switch (LOGGED_IN_USER_SITE_TYPE()) {
    case 1:
      return HO_Work_Flow_Role_List;

    case 2:
      return RO_Work_Flow_Role_List;

    case 3:
      return MINE_Work_Flow_Role_List;
    default:
      break;
  }
};
export const USER_Work_Flow_GLOBAL_Role_List = () => {
  switch (LOGGED_IN_USER_SITE_TYPE()) {
    case 1:
      return HO_ROLES;

    case 2:
      return RO_ROLES;

    case 3:
      return MINE_ROLES;
    default:
      break;
  }
};
export const TRAINEE_TYPE = {
  employee: "Employee",
  contractorPerson: "Contractor Person",
};

export const filterActionAdd = (data) => {
  return {
    type: "FILTER_STATUS_ADD",
    data: data,
  };
};

export const escalationEventLabel = {
  broadcast: "Broadcast",
  send_email_to_validate: "Send Email to validate",
  forgot_password: "Forgot Password",
  send_mobile_link_email_to_user: "Send Mobile Link Email To User",
  resent_user_creation_mail: "Resent User Creation Mail",
  training_overDue_vto: "Training OverDue Vto",
  medical_overDue_medicalOfficer: "Medical OverDue Medical Officer",
  medical_scheduled_medicalOfficer: "Medical scheduled Medical Officer",
  capa_revert_notification: "CAPA Revert Notification",
  task_reverted_notification: "Task Reverted Notification",
  meeting_scheduled: "Meeting Scheduled",
  meeting_taskOverDue: "Meeting TaskOverDue",
  escalated_meeting_taskOverDue_for_schedular:
    "Escalated Meeting TaskOverDue For Schedular",
  vfl_overDue_vflOfficer: "VFL OverDue VflOfficer",
  vfl_before_7_days_vflOfficer: "VFL Before 7 Days VflOfficer",
  vfl_before_3_days_vflOfficer: "VFL Before 3 Days VflOfficer",
  vfl_executive_alert_for_vfl_one_day_before_scheduled_date:
    "VFL Executive alert for VFL one day before scheduled date",
  incident_investigation_overDue: "Incident Investigation OverDue",
  escalated_incident_investigation_overDue: "Escalated Incident Investigation OverDue",
  low_incident_capa_overDue_capaOwner: "Low Incident CAPA OverDue CapaOwner",
  high_incident_capa_overDue_capaOwner: "High Incident CAPA OverDue CapaOwner",
  escalated_low_incident_capa_overDue_capaOwner:
    "Escalated Low Incident CAPA OverDue CapaOwner",
  four_five_incident_reported: "Four Five Incident Reported",
  four_five_incident_investigating: "Four Five Incident Investigating",
  four_five_incident_investigation_completed:
    "Four Five Incident Investigation Completed",
  incident_capa_assigned: "Incident CAPA Assigned",
  vfl_capa_assigned: "VFL CAPA Assigned",
  incident_capa_completed: "Incident CAPA Completed",
  vfl_capa_completed: "VFL CAPA Completed",
  ohse_task_completed: "OHSE Task Completed",
  medical_exam_completed: "Medical Exam Completed",
  training_completed: "Training Completed",
  four_five_severity_incident_close: "Four Five Severity Incident Close",
  medical_exam_list_to_medical_offcier: "Medical Exam List To Medical Offcier",
  training_list_to_vto: "Training List To VTO",
};

export const moduleType = {
  ehsIncidentDetails: "ehsIncidentDetails",
  ehs_vfls: "ehs_vfls",
  ehsEventSchedule: "ehsEventSchedule",
  ehsCapa: "ehsCapa",
  ehs_meeting_tasks: "ehs_meeting_tasks",
  ehsTrainingAssigners: "ehsTrainingAssigners",
  ehsMedicalAssigners: "ehsMedicalAssigners",
  // more module type will be added here
};

export const moduleTypeView = {
  ehsIncidentDetails: "Incident",
  ehs_vfls: "VFL",
  ehsEventSchedule: "OHSE",
  ehsCapa: "CAPA",
  ehs_meeting_tasks: "TASK",
  ehsTrainingAssigners: "Schedule Training",
  ehsMedicalAssigners: "Schedule Medical",
};
